import { render, staticRenderFns } from "./WallSelectionComponent.vue?vue&type=template&id=76d5d4fc&scoped=true&"
import script from "./WallSelectionComponent.vue?vue&type=script&lang=ts&"
export * from "./WallSelectionComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WallSelectionComponent.vue?vue&type=style&index=0&id=76d5d4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d5d4fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
